import React from 'react'
import { useAppSelector } from 'hooks'
import { tool, chartType } from 'store/AIMetricOT/reducerSlice'
import AIMetricOT from './AIMetricOT'
import Worldmap from './Worldmap'

const AIMetricOvertime = () => {
  const currentTool = useAppSelector(tool)
  const currentChartType = useAppSelector(chartType)

  return (
    <div style={{ height: '100%' }}>
      {currentTool === 'AIMOT' && currentChartType === 'bar' && <AIMetricOT />}
      {currentTool === 'AIMOT' && currentChartType === 'map' && <Worldmap />}
    </div>
  )
}

export default AIMetricOvertime
